module.exports = {"retryLogin.modal.content.text":"確認があなたのメールアドレスに送信されました。 アクティベーションを完了するには、メールの確認リンクをクリックしてから、このページに戻ってもう一度やり直してください。","retryLogin.modal.content.action.buttonLabel":"今すぐ再試行"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/ja/components/ModalContent/RetryLogin.json
// module id = 836
// module chunks = 0